<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <img src="/static/img/avatars/7.jpg" class="img-avatar" alt="">
        </template>
        <b-dropdown-header tag="div" class="text-center"><strong>Konto</strong></b-dropdown-header>
        <!--<b-dropdown-item><i class="fa fa-wrench"></i> Ustawienia</b-dropdown-item>-->
        <!--<b-dropdown-divider></b-dropdown-divider>-->
        <!--<b-dropdown-item @click="changePassword()"><i class="fa fa-lock"></i> Zmień hasło</b-dropdown-item>-->
        <b-dropdown-item @click="logout()"><i class="fa fa-sign-out"></i> Wyloguj</b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
import auth from './../../auth'
import config from './../../config'

export default {
  name: 'header-dropdown',
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    logout () {
      auth.logout()
    },
    changePassword () {
      window.location.href = config.services.users.url + '/change-password?redirectTo=' + window.location.origin
    }
  }
}
</script>
